import { render, staticRenderFns } from "./BookingLeadsMenu.vue?vue&type=template&id=995abbba&scoped=true"
import script from "./BookingLeadsMenu.vue?vue&type=script&lang=js"
export * from "./BookingLeadsMenu.vue?vue&type=script&lang=js"
import style0 from "./BookingLeadsMenu.vue?vue&type=style&index=0&id=995abbba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995abbba",
  null
  
)

export default component.exports